import { Drawer, Typography, List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { Page } from 'powerbi-client';

const drawerWidth = 240;
const styles = (theme: any) =>
    createStyles({
        drawerOpen: {
            width: drawerWidth,
            zIndex: 10,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            paddingTop: '70px',
            'background-color': theme.palette.fifth.backgroundColor,
        },
        drawerButton: {
            display: 'flex',
            textDecoration: 'none',
            '&:hover': {
                'background-color': '#1B4064',
                '& > div > div > span > span': {
                    color: '#FFFFFF',
                },
            },
        },
        drawerButtonActive: {
            'background-color': '#1B4064',
            '& > div > div > span > span': {
                color: '#FFFFFF',
            },
        },
        center: {
            display: 'inline-flex',
            'align-items': 'center',
            color: '#aaa',
        },
        organizationNameWrapper: {
            padding: '16px',
            whiteSpace: 'break-spaces',
        },
        organizationName: {
            color: theme.palette.textPrimary.color,
        },
    });

interface ReportPagesSidebarProps extends WithStyles<typeof styles> {
    pages: Page[];
    activePage: Page | undefined;
    setActivePage: (page: Page) => void;
    organizationName: string;
}

const ReportPagesSidebar = ({
    classes,
    pages,
    activePage,
    organizationName,
    setActivePage,
}: ReportPagesSidebarProps): JSX.Element => (
    <Drawer
        id="yeself-report-sidebar"
        anchor="left"
        variant="permanent"
        className={classes.drawerOpen}
        classes={{
            paper: classes.drawerOpen,
        }}
        open
    >
        <div className={classes.organizationNameWrapper}>
            <Typography variant="h6" className={classes.organizationName}>
                {organizationName}
            </Typography>
        </div>
        <List>
            {pages.map((page, index) => (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                    id="yeself-report-sidebar-button"
                    key={`yeself-report-sidebar-button-${page.displayName}`}
                    role="button"
                    tabIndex={index}
                    className={`${classes.drawerButton} ${
                        page === activePage ? classes.drawerButtonActive : ''
                    }`}
                    onClick={() => {
                        setActivePage(page);
                    }}
                >
                    <ListItem key={`yeself-report-sidebar-button-item-${page.displayName}`} button>
                        <ListItemText
                            primary={
                                <span className={classes.center}>
                                    <span>{page.displayName}</span>
                                </span>
                            }
                        />
                    </ListItem>
                </a>
            ))}
        </List>
        <Divider />
    </Drawer>
);

export default withStyles(styles)(ReportPagesSidebar);
